<template>
  <div class="pagination-wrapper clearfix" v-if="rowsCount > 0">
    <div class="results">
      <p><strong>{{ rowsCount }}</strong> registro(s) encontrado(s)</p>
    </div>

    <nav aria-label="Page navigation">
      <ul class="pagination">
        <li
          v-for="(item, index) in items"
          :key="index"
          :class="[{ 'active': item === activePage }, { 'no-link': item === '...' }]"
        >
          <span v-if="item === activePage || item === '...'">{{ item }}</span>
          <a
            v-else
            :title="`Página ${item}`"
            @click="getPageItem(item)"
          >
            {{ item }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    items: {
      type: Array,
      required: true
    },
    activePage: {
      type: Number,
      required: true
    },
    rowsCount: {
      type: Number,
      default: 0
    }
  },
  methods: {
    getPageItem (page) {
      this.$emit('getPageItem', page)
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-wrapper {

  .results {
    float: left;

    p {
      font-size: 11.5px;
      margin: 6px 0 0;
    }
  }

  nav {
    float: right;
    height: 27px;

    .pagination {
      margin: 0;
    }
  }
}

.pagination-wrapper nav li.no-link span:hover {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pagination/Pagination.vue